export class AssumeRoleDetailsModel {
    logzioAWSAccountId;
    assignedExternalId;
}
//# sourceMappingURL=assume-role-detail.js.map